// extracted by mini-css-extract-plugin
module.exports = {"content":"DataTable_content__CP8iZ","table":"DataTable_table__12YVk"};